import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalConstants} from '../global-constants';
import {Observable} from 'rxjs';
import {AppSetting} from "./app-settings.models";

@Injectable({
    providedIn: 'root'
})
export class AppSettingsService {

    constructor(private http: HttpClient) {
    }

    findAll(): Observable<Array<AppSetting>> {
        return this.http.get<Array<AppSetting>>(`${GlobalConstants.apiURL}/app-settings/find-all`);
    }

    update(appSettings): Observable<Array<AppSetting>> {
        return this.http.post<Array<AppSetting>>(`${GlobalConstants.apiURL}/app-settings/update`, {
            appSettings
        });
    }
}
